import { ReactNode } from "react";

interface MenuBookPageProps {
  children: ReactNode;
  pageNumber?: number;
  isLeftPage?: boolean;
}

const MenuBookPage = ({ children, pageNumber, isLeftPage }: MenuBookPageProps) => {
  return (
    <div className={`menu-book-page ${isLeftPage ? 'left-page' : 'right-page'} bg-gradient-to-br from-background/98 via-card/95 to-background/98 backdrop-blur-md p-4 sm:p-6 lg:p-8 shadow-2xl pointer-events-auto h-full relative overflow-hidden`}
    >
      {/* Decorative corner ornaments */}
      <div className="absolute top-0 left-0 w-8 h-8 sm:w-12 sm:h-12 lg:w-16 lg:h-16 opacity-20">
        <svg viewBox="0 0 100 100" className="text-gold">
          <path d="M 0,0 L 0,50 Q 0,0 50,0 Z" fill="currentColor" opacity="0.3"/>
        </svg>
      </div>
      <div className="absolute top-0 right-0 w-8 h-8 sm:w-12 sm:h-12 lg:w-16 lg:h-16 opacity-20 rotate-90">
        <svg viewBox="0 0 100 100" className="text-gold">
          <path d="M 0,0 L 0,50 Q 0,0 50,0 Z" fill="currentColor" opacity="0.3"/>
        </svg>
      </div>
      
      <div className="flex flex-col h-full relative z-10">
        <div className="flex-1 overflow-y-auto menu-scrollbar pr-2 sm:pr-3">
          {children}
        </div>
        {pageNumber && (
          <div className="text-center mt-4 sm:mt-6 pt-3 sm:pt-4 border-t border-gold/30 relative">
            <div className="absolute left-1/2 -translate-x-1/2 -top-2 w-12 h-px bg-gradient-to-r from-transparent via-gold to-transparent"></div>
            <span className="text-gold/70 font-display text-xs sm:text-sm tracking-widest">{pageNumber}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MenuBookPage;
